import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import { capitalize } from "../../utils/helpers";

const SelectListGroup = props => {
  const { name, value, error, info, onChange, options } = props;

  const selectOptions = options.map((option, index) => (
    <option key={index} value={option.name}>
      {capitalize(option.name)}
    </option>
  ));

  return (
    <div className="form-group">
      <select
        className={classnames("form-control", {
          "is-invalid": error
        })}
        name={name}
        value={value}
        onChange={onChange}
      >
        <option key="-1" value=""></option>
        {selectOptions}
      </select>
      {info && <small className="form-text text-muted">{info}</small>}
      {error && <div className="invalid-feedback">{error}</div>}
    </div>
  );
};

SelectListGroup.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  info: PropTypes.string,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array
};

export default SelectListGroup;
